import { 
    IconButton,
    makeStyles, 
    Modal, 
    Typography 
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';

  const useStyles = makeStyles((theme) => ({
    paper: {
      display: 'flex',
      width: 'inherit',
      justifyContent: 'center',
      flexDirection: 'column',
      backgroundColor: theme.palette.background.paper,
    },
  }));
  

const CustomModal = ({ open, handleClose, title, children }) => {
    const classes = useStyles();
    return (
        
        <Modal
            open={open}
            onClose={handleClose}
            style={{display:'flex', justifyContent:'center', alignItems: 'center'}}
        >
            <div className={classes.paper}>
                <div
                    style={{ display: 'inherit', width: 'inherit', alignItems: 'center', justifyContent: 'space-between', padding: '0.8em 1em', borderBottom: '3px solid #eee'}}
                >
                    <Typography
                        variant="h6"
                    >
                        {title}
                    </Typography>
                    <IconButton
                        onClick={() => handleClose()}
                    >
                        <CloseIcon/>
                    </IconButton>
                </div>
                
                <div
                    style={{
                        width: 'inherit',
                        margin: 'auto',
                        padding: '0.5em 2em'
                    }}
                >
                    {children}
                </div>
            </div>
        </Modal>
    );
}

export default CustomModal;
